import { render } from "./OnlineBookingSidebarSteps.vue?vue&type=template&id=485fba88"
import script from "./OnlineBookingSidebarSteps.vue?vue&type=script&lang=js"
export * from "./OnlineBookingSidebarSteps.vue?vue&type=script&lang=js"

import exportComponent from "/__w/system/system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__